module.exports = __webpack_public_path__ + "static/media/manage.1dd6c3e6.png";